import React from "react";

export const Page5English = () => {
  return (
    <div className="page-container">
      <p>Mr. S. Durairaj </p>
      <p>
        My beloved wife Poorani and I live in Bangalore with our wealthy
        children Selvan. S.T. Nareshkumar, Selvi. S.T. Viswanandini. My brothers
        and relatives also live here.
      </p>
      <p>
        My grandfather Vadivel Upathiyar lived in Kolapadu village about 80
        years ago and worked as a school teacher. My father's name is T.V.
        Sundaresa Bhagavathar, mother's name Kamalammal, my grandfather and
        father, who have passed away, have left behind an indelible legacy for
        our families, and we consider them to be our clan deities Sri Adhiannan
        and Sri Ayyanar in Kolapadu village.
      </p>
      <p>
        Even though we brothers are engaged in different professions, a great
        force that has kept us together till today is our clan deities Sri
        Adhiannan and Sri Ayyanar. We have made it a habit to come here with our
        family once a year and perform the clan deity puja.
      </p>
      <p>
        We have had the idea for many years to renovate and perform the
        Kumbabhishekam at the two temples in Kolapadu village. In keeping with
        the saying, "Whatever the Lord orders to happen, when and by whom, it
        will happen, then and then," we have successfully conducted the
        renovation and Kumbabhishekam this year with the permission and
        cooperation of the villagers.
      </p>
      <p>
        Although many people collaborated with us in this work, we found one
        important person who was a good friend, a good helper, and a person who
        was very trustworthy and enthusiastic about serving God. He is the kind
        G. Ramesh, who owns the Sivashakti Mallikai in Kolappad. He has been a
        great help to us. On behalf of our family, I express my gratitude and
        respect to those who did the renovation work as per our wishes, erected
        the new Adhiannan idol and painted it beautifully, and to Mr. Veeramani
        Sivacharya and the villagers of Kolappad who cooperated in making the
        Kumbabhishekam a success.
      </p>
      <p>
        I also express my heartfelt gratitude to retired teacher S. Vasudevan,
        who prepared the special flower for the Kumbabhishekam.
      </p>
      <p>
        AOn behalf of the family of Amarar
        <strong> T.T. Sundara Bhagavathar</strong>
      </p>
      <strong>S. Durairaj, </strong>
      <p>Adhi Enterprises, Bangalore.</p>
    </div>
  );
};
